import { EffectsModal } from '../EffectsModal';

export const HousesDestroyedModal = ({ title }) => EffectsModal({
  title,
  desc: 'Whenever possible, numbers of houses destroyed are listed.',
});
